// extracted by mini-css-extract-plugin
var _1 = "accept-GR1HW";
var _2 = "cancel-SC4oG";
var _3 = "confirmation-bSele";
var _4 = "hover-DqNCE";
export { _1 as "accept", _2 as "cancel", _3 as "confirmation", _4 as "hover" }
